import {
    Component, Mixins,
} from 'vue-property-decorator';
import CoreMixin from '@nodes/mixins/Core';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { YModal, YCheckbox } from '@components/index';
import Props from './props';

interface ModalRef extends Vue {
    open(): void;
    close(): void;
}

@Component({
    components: {
        YModal,
        YCheckbox,
    },
})

/**
 * @name AlertMe
 */
export default class AlertMe extends Mixins(HybridMixin, CoreMixin, Props) {
    activeChannels = {}

    /**
     * Refs types
     */
    $refs!: {
        alertMeModal: ModalRef;
    };

    /**
     * Open alert me modal
     */
    openAlertMeModal() {
        if (this.$store.getters['auth/isLoggedIn']) {
            this.$refs.alertMeModal.open();
        } else {
            this.$store.dispatch('auth/setRedirect', {
                name  : this.$route.name,
                params: { ...this.$route.params },
                query : { ...this.$route.query },
            });
            this.$router.push({ name: 'auth-login' });
        }
    }

    /**
     * Submit availabilityAlert modal
     */
    submitAlert() {
        this.$wait.start('loading-submit-alert-me');
        this.$services.Market.availabilityAlert({
            id     : this.getValue('postId'),
            channel: Object.entries(this.activeChannels)
                .map((item) => (item[1] ? item[0] : null))
                .filter((item) => item),
            status: 1,
        }).then(() => {
            this.$toast.success(this.$t('alert-me.modal.success'));
            this.$refs.alertMeModal.close();
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('loading-submit-alert-me');
        });
    }
}
